__turbopack_context__.v({
  "ProductAccessoryCard": "p2YZDa_ProductAccessoryCard",
  "ProductAccessoryCard__Button": "p2YZDa_ProductAccessoryCard__Button",
  "ProductAccessoryCard__ButtonText": "p2YZDa_ProductAccessoryCard__ButtonText",
  "ProductAccessoryCard__Container": "p2YZDa_ProductAccessoryCard__Container",
  "ProductAccessoryCard__Description": "p2YZDa_ProductAccessoryCard__Description",
  "ProductAccessoryCard__Image": "p2YZDa_ProductAccessoryCard__Image",
  "ProductAccessoryCard__Image--Loaded": "p2YZDa_ProductAccessoryCard__Image--Loaded",
  "ProductAccessoryCard__ImageWrap": "p2YZDa_ProductAccessoryCard__ImageWrap",
  "ProductAccessoryCard__Title": "p2YZDa_ProductAccessoryCard__Title",
});
